import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import { SkipNavigation } from './components/ui/SkipNavigation';
import { ThemeProvider } from './contexts/ThemeContext';
import ErrorBoundary from './components/ErrorBoundary';

// Lazy load pages for code splitting
const HomePage = lazy(() => import('./pages/HomePage'));
const FeaturesPage = lazy(() => import('./pages/FeaturesPage'));
const DocsPage = lazy(() => import('./pages/DocsPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <Router>
          <div className="min-h-screen bg-white dark:bg-gray-950 flex flex-col">
            <SkipNavigation />
            <Header />
            <main id="main-content" className="flex-1 pt-16 lg:pt-20" tabIndex={-1}>
              <Suspense fallback={
                <div className="flex items-center justify-center min-h-[50vh]" role="status" aria-label="Loading page content">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" aria-hidden="true"></div>
                  <span className="sr-only">Loading...</span>
                </div>
              }>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/features" element={<FeaturesPage />} />
                  <Route path="/docs" element={<DocsPage />} />
                  <Route path="/about" element={<AboutPage />} />
                </Routes>
              </Suspense>
            </main>
            <Footer />
          </div>
        </Router>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;